import flatMap from 'lodash/flatMap';
import { arrayOf, func, shape, string } from 'prop-types';
import React from 'react';
import Select from 'react-select';
import { Col, FormGroup, Label } from 'reactstrap';

import withProducts from '../../products/withProducts/with-products';
import { clBusinessLineShape, productShape } from '../../prop-types';

function productOptions(filteredProducts) {
  return filteredProducts.map(product => ({
    label: `${product.name} - ${product.business}, ${product.productGroup}`,
    value: product.code,
    product,
  }));
}

export function productIds(campaignLines) {
  return flatMap(
    campaignLines.map(lines => lines.products.map(product => product.id)),
  );
}

function NewProductSelection({
  products,
  existingCampaignLines,
  selectedProductOption,
  onProductChange,
  productFilter,
}) {
  const filteredProducts = productFilter(
    products,
    productIds(existingCampaignLines),
  );

  return (
    <FormGroup row>
      <Label sm={4}> Select Product </Label>
      <Col sm={8}>
        <Select
          options={productOptions(filteredProducts)}
          name="product"
          value={selectedProductOption}
          placeholder="Select product"
          onChange={onProductChange}
        />
      </Col>
    </FormGroup>
  );
}

NewProductSelection.propTypes = {
  products: arrayOf(productShape.isRequired).isRequired,
  existingCampaignLines: arrayOf(clBusinessLineShape.isRequired).isRequired,
  selectedProductOption: shape({
    label: string,
    value: string,
    product: productShape,
  }),
  onProductChange: func.isRequired,
  productFilter: func.isRequired,
};

NewProductSelection.defaultProps = {
  selectedProductOption: undefined,
};

export default withProducts({ removeDeprecatedProducts: true })(
  NewProductSelection,
);
